<script>
  export default {
    name: "ToggleDiv",
    data: () => ({
      isShow1: false,
      isShow2: false,
      isShow3: false,
      isShow4: false,
      isShow5: false,
      isShow6: false,
    }),

    props: {
      msg: String,
    },
  };
</script>
<template>

    <h1>Innenohr - Aufbau und Funktion</h1>
     <div align="center" id="cardsWrapper"> 

      <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;">
        <!-- <h5 class="card-title">Aufbau - Grafik</h5> -->
        <div class="card-body" align="center">
          
        
           <img class="card-img-top" src="@/assets/Uebersicht_Ohr.jpg" alt="Card image cap">
          <br>
          <br>
          
        </div>
        
        
        <button class="btn btn-secondary"  @click="isShow1 = !isShow1" v-if="!isShow1">Weiter</button>
      </div>

      <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;" v-if="isShow1">
        <h5 class="card-title">Aufbau</h5>
        <div class="card-body" align="left">
          Das Innenohr besteht aus einer Hörschnecke, genannt <b>Cochlea</b>, wie auch dem Hörnerv.
          <br>
          <br>
          Die Cochlea ist aus drei Bogengängen aufgebaut, welche die drei Ebenen des Raums abbilden und dem Gleichgewichtssinn dienen.
          <br>
          <br>    

            
          </div>
        <button class="btn btn-secondary"  @click="isShow2 = !isShow2" v-if="!isShow2">Weiter</button>
      </div>      

      <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 60%;" v-if="isShow2">
          <h5>Funktion</h5>
          <div class="card-body" align="left">
          Im Gehör findet eine Spektralanalyse nach Art der Fourier-Transformation statt (diese wird unter 3. weiter erläutert).
          Diese Analyse wird auch das Ohmsche Gesetz der Psychoakustik genannt.
          <br>
          <br>
          In der Cochlea gibt es zwei Räume, welche sich die <b>Scala Media</b>  und die <b>Scala Vestibuli</b>  nennen. Diese werden durch die <b>Basilarmembran</b> getrennt. Auf dieser Membran wird durch den Schall eine Wanderwelle ausgelöst.
          <br>
          <br>
          →  Hierbei gilt: je tiefer die Frequenz, desto näher an der Spitze der schneckenförmig aufgerollten Cochlea erfolgt die max. Auslenkung der Basilarmembran (Ortsprinzip der Wanderwelle).
          <br>
          <br>
          → frequenztypisches Maximum
          <br>
          <br>
          → Ort des Maximums entspricht Logarithmus der Frequenz
        <br>
        <br>
          Auf der Basilarmembran befindet sich wiederum das <b>Cortische Organ</b>, welches den eigentlichen Gehörsinn darstellt. Für seine Funktion sind feine <b>Haarzellen</b>  wie auch die <b>Tektorialmembran</b> essentiell.
         <br>
         <br>
          →  Diese Haarzellen sind die eigentlichen Sensoren des menschlichen Gehörs. 
          <br>
          <br>
          Basilar- und Tektorialmembran verlaufen parallel und bewegen sich gegeneinander, was zu einer stimulation der verschieden langen Härchen führt. Diese Bewegung führt zur Ausschüttung von Botenstoffen an den Nervenfasern der Haarzellen, welche schlussendlich als Signal an den zentralen Gehörsinn weitergeleitet werden.
        <br>
        <br>
        <div class="bild22">
        <img class="card-img-top" src="@/assets/freq.png" alt="Frequenz">
        <br>
        <br>
        </div>
        <div class="bild23">
        <img class="card-img-top" src="@/assets/cochlea.png" alt="Cochlea">
        </div>
  
        </div>
      </div>  

    </div>
</template>
<style>
.bild22{
  padding-left: 250px;
  padding-right: 250px;

}
.bild23{
  padding-left: 125px;
  padding-right: 125px;
}
</style>